/**
 * data-read-less = mandatory.
 * Use as:
    <read-more>
      <p class="inline" data-read-more-content-truncate>
        {{- truncated text here -}}
      </p>
      <p class="inline hidden" data-read-more-content-full>
        {{- full text here -}}
      </p>
    <button
      class="link font-normal"
      data-read-more-trigger
      data-show-type="show" data-read-less="{%- render "format-translation", namespace: "general.read_less", fallback: "Read less" -%}"
    >
      {%- render "format-translation",
        namespace: "general.read_more",
        fallback: "Read more"
      -%}
    </button>
  </read-more>
 */
class ReadMore extends HTMLElement {
  constructor() {
    super();

    this.readMoreTrigger = this.querySelector('[data-read-more-trigger]');
    this.readMoreContentTruncate = this.querySelector('[data-read-more-content-truncate]');
    this.readMoreContent = this.querySelector('[data-read-more-content-full]');

    this.showText = this.readMoreTrigger?.innerText;
    this.hideText = this.readMoreTrigger?.dataset.readLess;

    this.readMoreTrigger?.addEventListener('click', (event) => {
      const target = event.currentTarget;
      const type = target.dataset.showType;
      this.toggleResults(type, target);
      target.blur();
    });
  }

  toggleResults(type, target) {
    if (type === 'show') {
      target.dataset.showType = 'hide';
      target.innerText = this.hideText;
      this.readMoreContentTruncate.classList.add('hidden');
      this.readMoreContent.classList.remove('hidden');
    } else {
      target.dataset.showType = 'show';
      target.innerText = this.showText;
      this.readMoreContentTruncate.classList.remove('hidden');
      this.readMoreContent.classList.add('hidden');
    }
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore);
}
